/**
 * The two modes of the page in the top bar: "Ảnh thẻ" (/) and "Ảnh chuyên nghiệp" (/chinh-anh). A plain click
 * changes the mode in place (the photo and the choices stay); a link still opens in a new tab with Ctrl / middle click.
 */
import type { MouseEvent } from "react";
import { EDIT } from "../messages";
import type { Mode } from "../studio/types";

export const EDIT_PATH = "/chinh-anh";

export const pathOf = (mode: Mode) => (mode === "pro" ? EDIT_PATH : "/");

export function TopNav({ current, onMode }: { current: Mode; onMode: (mode: Mode) => void }) {
  const search = typeof window !== "undefined" ? window.location.search : "";  // keeps ?user= on a dev server
  function go(e: MouseEvent, mode: Mode) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;   // new tab / window
    e.preventDefault();
    onMode(mode);
  }
  const link = (mode: Mode, text: string, short = text) => (
    <a href={`${pathOf(mode)}${search}`} className={current === mode ? "is-current" : undefined} aria-label={text}
       aria-current={current === mode ? "page" : undefined} onClick={(e) => go(e, mode)}>
      <span className="nav-long">{text}</span>
      {short !== text && <span className="nav-short" aria-hidden="true">{short}</span>}
    </a>
  );
  return (
    <nav className="topnav" aria-label="Chế độ">
      {link("idphoto", EDIT.nav.idphoto)}
      {link("pro", EDIT.nav.edit, EDIT.nav.editShort)}
    </nav>
  );
}
